const useFollowAuthCheck = () => {
  const { isLoggedIn } = useAuth();
  const { openOnboardingDialog } = useOnboardingDialog();

  return (data: FollowOnboardingEntryData["data"]) => {
    if (isLoggedIn.value) return;

    openOnboardingDialog({
      type: OnboardingEntryType.Follow,
      data,
    });
  };
};

export default useFollowAuthCheck;
